<script setup lang="ts">
import GleimLogo from '@/components/GleimLogo.vue';

defineProps<{
    toggleableSideNav: boolean;
    leftDrawerOpen?: boolean;
}>();

defineEmits(['toggleLeftDrawer']);

</script>
<template>
    <q-header
        id="fsum-header"
        class="fixed bg-white z-top"
    >
        <q-toolbar>
            <q-btn
                v-if="toggleableSideNav"
                id="fsum-menu"
                class="fsum-menu-button"
                dense
                flat
                round
                :icon="leftDrawerOpen ? 'menu_open' : 'menu'"
                :aria-label="`${leftDrawerOpen ? 'close' : 'open'} side menu`"
                :title="`${leftDrawerOpen ? 'close' : 'open'} side menu`"
                role="button"
                tabindex="0"
                @click="$emit('toggleLeftDrawer')"
            />
            <div
                v-else
                class="fsum-menu-button"
            />
            <q-toolbar-title class="q-px-none">
                <GleimLogo />
            </q-toolbar-title>
        </q-toolbar>
    </q-header>
</template>
<style scoped lang="scss">
#fsum-header {
    height: var(--fsum-header-height);
    width: 100%;
    z-index: 2;
}
#fsum-menu :deep(i) {
    color: var(--fsum-bg-blue);
    font-size: 24px;
}
.fsum-menu-button {
    width: 2.4em;
    height: 2.4em;
    font-size: 14px;
}
</style>
